const urlFriendly = (input) => {
	let output = input.toLowerCase();
	output = output.replace(/\s+/g, '-');
	return output;
};

export default urlFriendly;
